import { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react';

const dict = {
  en: {
    brand_tagline: "Your whole bazaar, just a tap away.",
    nav_search: "Search", nav_stores: "Stores", nav_kirana: "Kirana", nav_cloth: "Cloth",
    nav_vegetables: "Vegetables", nav_become: "Sell on BharatCart",
    sign_in: "Sign In", logout: "Logout", orders: "Orders", dashboard: "Dashboard",
    tender_cta: "Get best price from local shops",
    tender_subtitle: "Tell us what you need — shop owners bid; you see only the best deal.",
    request_quote: "Request a quote",
    cart: "Cart", empty_cart: "Your cart is empty",
    place_order: "Place order", checkout: "Checkout",
  },
  hi: {
    brand_tagline: "तेरा पूरा बाज़ार, एक टैप पर।",
    nav_search: "खोजें", nav_stores: "दुकानें", nav_kirana: "किराना", nav_cloth: "कपड़ा",
    nav_vegetables: "सब्ज़ी", nav_become: "अपनी दुकान खोलें",
    sign_in: "लॉगिन", logout: "लॉगआउट", orders: "ऑर्डर", dashboard: "डैशबोर्ड",
    tender_cta: "सबसे कम दाम पाएं दुकानदारों से",
    tender_subtitle: "बताइए क्या चाहिए — दुकानदार बोली लगाएंगे; आप सिर्फ़ बेस्ट डील देखेंगे।",
    request_quote: "भाव मंगवाएं",
    cart: "कार्ट", empty_cart: "आपका कार्ट खाली है",
    place_order: "ऑर्डर करें", checkout: "चेकआउट",
  },
};

const I18nContext = createContext({ lang: 'en', t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem('mandispot_lang') || 'en'; }
    catch (e) { console.warn('[i18n] failed to read lang', e); return 'en'; }
  });
  useEffect(() => {
    try { localStorage.setItem('mandispot_lang', lang); }
    catch (e) { console.warn('[i18n] failed to persist lang', e); }
  }, [lang]);
  const setLang = useCallback((l) => setLangState(l), []);
  const t = useCallback((k) => dict[lang]?.[k] ?? dict.en[k] ?? k, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
